module.exports = __webpack_public_path__ + "@/assets/img/07.6f397d30.svg";